import React from "react";
import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";

export const eur = (n) => `${Math.round(Number(n) || 0).toLocaleString("fr-FR")} €`;

export const StepBar = ({ step, total, labels = [] }) => (
  <div className="mb-6" data-testid="guide-stepbar">
    <div className="flex justify-between text-xs text-brand-green/50 mb-2"><span>Étape {step}/{total}</span><span>{labels[step - 1]}</span></div>
    <div className="h-1.5 bg-brand-soft rounded-full overflow-hidden"><div className="h-full bg-brand-limeDark transition-[width] duration-500" style={{ width: `${(step / total) * 100}%` }} /></div>
  </div>
);

export const Primary = ({ children, busy, className = "", ...p }) => (
  <button {...p} disabled={busy || p.disabled}
    className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-brand-lime hover:bg-brand-limeDark disabled:opacity-50 text-brand-greenDeep font-semibold transition-colors ${className}`}>
    {busy && <Loader2 className="w-4 h-4 animate-spin" />}{children}{!busy && <ArrowRight className="w-4 h-4" />}
  </button>
);

export const Back = ({ onClick }) => (
  <button type="button" onClick={onClick} className="inline-flex items-center gap-1 text-sm text-brand-green/60 hover:text-brand-greenDeep" data-testid="guide-back"><ArrowLeft className="w-4 h-4" /> Retour</button>
);

export const Footer = ({ onBack, children }) => (
  <div className="sticky bottom-0 -mx-6 sm:-mx-8 px-6 sm:px-8 py-4 mt-6 bg-white border-t border-brand-soft flex items-center justify-between gap-3">
    {onBack ? <Back onClick={onBack} /> : <span />}
    <div className="flex flex-wrap justify-end gap-2">{children}</div>
  </div>
);

export const Num = ({ label, value, onChange, suffix, testid, optional, step = "any" }) => (
  <label className="block">
    <span className="block text-xs font-medium text-brand-green/70 mb-1">{label}{optional && <span className="text-brand-green/40"> (facultatif)</span>}</span>
    <div className="relative">
      <input type="number" step={step} min="0" value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="input pr-12" data-testid={testid} />
      {suffix && <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-brand-green/50">{suffix}</span>}
    </div>
  </label>
);

export const PropertySelect = ({ properties, value, onChange, testid = "guide-property-select" }) => (
  <label className="block">
    <span className="block text-xs font-medium text-brand-green/70 mb-1">Bien concerné</span>
    <select value={value} onChange={(e) => onChange(e.target.value)} className="input" data-testid={testid}>
      {properties.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
    </select>
  </label>
);

export const Stat = ({ label, value, tone = "", testid }) => (
  <div className="rounded-2xl bg-brand-softer px-4 py-3" data-testid={testid}>
    <p className="text-xs text-brand-green/60">{label}</p>
    <p className={`text-base sm:text-xl font-bold mt-0.5 whitespace-nowrap ${tone || "text-brand-greenDeep"}`}>{value}</p>
  </div>
);

export const Disclaimer = ({ children }) => <p className="text-[11px] text-brand-green/50 mt-4 italic">{children}</p>;
